'use client';
import { LoginResponse } from 'api-types/src/data-contract/auto-generated/auth-model';
import { sendGTMEvent } from '../sendGTMEvent';

/**
 * Tracks login events when users successfully authenticate.
 * 
 * This function sends a simple login event with the user ID to track
 * successful authentication attempts. Only sends the event if a valid
 * user ID is provided.
 * 
 * @param userId - The unique identifier for the logged-in user
 */
export const trackLogin = (user: LoginResponse | undefined) => {
  const userId = user?.firstName;
  // Only send login event if we have a valid user ID
  if (!userId || userId.trim() === '') {
    console.warn('trackLogin: Cannot track login without a valid user ID');
    return;
  }

  sendGTMEvent({
    event: 'login',
    user_id: userId,
  });
};